import React from 'react';
import { Translate } from 'react-jhipster';

import MenuItem from 'app/shared/layout/menus/menu-item';

const EntitiesMenu = () => {
  return (
    <>
      {/* prettier-ignore */}
      <MenuItem icon="asterisk" to="/organization">
        <Translate contentKey="global.menu.entities.organization" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/organization-configuration">
        <Translate contentKey="global.menu.entities.organizationConfiguration" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/submission">
        <Translate contentKey="global.menu.entities.submission" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/organization-workflow">
        <Translate contentKey="global.menu.entities.organizationWorkflow" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/submission-request">
        <Translate contentKey="global.menu.entities.submissionRequest" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/env-var">
        <Translate contentKey="global.menu.entities.envVar" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/workflow-documents">
        <Translate contentKey="global.menu.entities.workflowDocuments" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/system-ai-function">
        <Translate contentKey="global.menu.entities.systemAiFunction" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/system-ai-prompt">
        <Translate contentKey="global.menu.entities.systemAiPrompt" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/merchant">
        <Translate contentKey="global.menu.entities.merchant" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/deal">
        <Translate contentKey="global.menu.entities.deal" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/user-deals">
        <Translate contentKey="global.menu.entities.userDeals" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/product">
        <Translate contentKey="global.menu.entities.product" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/deal-product">
        <Translate contentKey="global.menu.entities.dealProduct" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/user-cash-back">
        <Translate contentKey="global.menu.entities.userCashBack" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/user-cash-back-deal">
        <Translate contentKey="global.menu.entities.userCashBackDeal" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/brand">
        <Translate contentKey="global.menu.entities.brand" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/publisher">
        <Translate contentKey="global.menu.entities.publisher" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/customer">
        <Translate contentKey="global.menu.entities.customer" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/correction">
        <Translate contentKey="global.menu.entities.correction" />
      </MenuItem>
      {/* jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here */}
    </>
  );
};

export default EntitiesMenu;
